<template>
	<div>
		<!-- Modal: Mark as Incorrect -->
		<pui-modal-dialog-form
			:titleText="$t('modal.portcallinvoices.markAsIncorrect.title')"
			:modelName="modelName"
			:dialogName="portcallinvoicesMarkAsIncorrectModal"
			:onOk="onOkMarkAsIncorrectModal"
			:onShow="onShowMarkAsIncorrectModal"
			:widthDialog="800"
		>
			<template slot="message" slot-scope="data">
				<v-row dense>
					<!-- Comments (required) -->
					<v-col cols="12">
						<pui-text-area
							:id="`comments-portcallinvoices-incorrect`"
							v-model="data.modalData.incorrectcomments"
							:label="$t('portcallinvoices.incorrectcomments')"
							required
							toplabel
							maxlength="256"
						></pui-text-area>
					</v-col>
				</v-row>
			</template>
		</pui-modal-dialog-form>

		<pui-modal-dialog-form
			:titleText="$t('action.portcallinvoices.finalizeInvoice')"
			:modelName="modelName"
			:dialogName="portcallinvoicesFinalizeInvoiceModal"
			:widthDialog="800"
			:onOk="onOkFinalizeInvoiceModal"
		>
			<template slot="message">
				<v-layout wrap class="justify-center">
					<v-flex xs12>
						{{ $t('action.portcallinvoices.completedInvoiceMessage') }}
					</v-flex>
				</v-layout>
			</template>
		</pui-modal-dialog-form>
	</div>
</template>

<script>
export default {
	name: 'portcallinvoices-modals',

	data() {
		return {
			portcallinvoicesMarkAsIncorrectModal: 'portcallinvoicesMarkAsIncorrect',
			portcallinvoicesFinalizeInvoiceModal: 'portcallinvoicesFinalizeInvoice'
		};
	},
	props: {
		modelName: {
			required: true,
			type: String
		}
	},
	methods: {
		onOkFinalizeInvoiceModal(modalData) {
			const params = {
				// por si acaso, intenta primero headerPk y si no, usa invoiceid directo
				invoiceId: modalData.headerPk?.invoiceid || modalData.invoiceid
			};

			console.log('Finalizing invoice with params:', params);
			// Use direct URL to the controller endpoint
			const urlController = '/portcallinvoices/finalizeInvoice';
			const title = this.$puiI18n.t('action.portcallinvoices.finalizeInvoice');

			return new Promise((resolve) => {
				this.$puiRequests.postRequest(
					urlController,
					null,

					() => {
						this.$puiEvents.$emit('onPui-action-running-ended-' + this.modelName);
						this.$puiEvents.$emit('refreshForm-action-running-ended-' + this.modelName);
						const message = this.$puiI18n.t('puiaction.notifySuccess');
						this.$puiNotify.success(message, title);
						resolve(true);
					},
					(e) => {
						let message = this.$puiI18n.t('puiaction.notifyError');
						if (e.response && e.response.data) {
							message = e.response.data.message;
						}
						this.$puiEvents.$emit('onPui-action-running-ended-' + this.modelName);
						this.$puiNotify.error(message, title, 0, true);
						resolve(false);
					},
					null,
					params
				);
			});
		},

		// Mark as Incorrect Modal
		onOkMarkAsIncorrectModal(modalData) {
			if (!modalData.incorrectcomments || modalData.incorrectcomments.trim() === '') {
				this.$puiNotify.error(
					this.$puiI18n.t('modal.portcallinvoices.markAsIncorrect.error.commentsRequired'),
					this.$puiI18n.t('puiaction.notifyTitle')
				);
				return Promise.resolve(false);
			}

			const params = {
				invoiceId: modalData.invoiceid,
				comments: modalData.incorrectcomments
			};

			// Use direct URL to the controller endpoint
			const url = '/portcallinvoices/markAsIncorrect';

			return new Promise((resolve) => {
				this.$puiRequests.postRequest(
					url,
					null,
					() => {
						this.$puiNotify.success(
							this.$puiI18n.t('modal.portcallinvoices.markAsIncorrect.success'),
							this.$puiI18n.t('puiaction.notifyTitle')
						);
						this.$puiEvents.$emit('onPui-action-running-ended-' + this.modelName);
						this.$puiEvents.$emit('onPui-refresh-grid-' + this.modelName);
						resolve(true);
					},
					(e) => {
						let message = this.$puiI18n.t('puiaction.notifyError');
						if (e.response && e.response.data) {
							message = e.response.data.message;
						}
						this.$puiEvents.$emit('onPui-action-running-ended-' + this.modelName);
						this.$puiNotify.error(message, this.$puiI18n.t('puiaction.notifyTitle'));
						resolve(false);
					},
					null,
					params
				);
			});
		},

		onShowMarkAsIncorrectModal(modalData) {
			// Clear previous comments
			this.$set(modalData, 'incorrectcomments', '');
		}
	}
};
</script>
